"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUser = exports.getUserEmailAddress = exports.getIsUngatedForImageOptimization = exports.getIsUngatedForCanva = exports.getIsUngatedForVideoExperiments = exports.getUserId = exports.getHasFileManagerAccessScope = exports.getHasDirectFileLinkAccessScope = exports.getHasVideoIntegrationScope = void 0;

var _Constants = require("../Constants");

var getHasVideoIntegrationScope = function getHasVideoIntegrationScope(state) {
  return state.auth.user.scopes.indexOf(_Constants.MARKETING_VIDEO_SCOPE) > -1;
};

exports.getHasVideoIntegrationScope = getHasVideoIntegrationScope;

var getHasDirectFileLinkAccessScope = function getHasDirectFileLinkAccessScope(state) {
  return state.auth.user.scopes.indexOf(_Constants.DIRECT_FILE_LINK_ACCESS) > -1;
};

exports.getHasDirectFileLinkAccessScope = getHasDirectFileLinkAccessScope;

var getHasFileManagerAccessScope = function getHasFileManagerAccessScope(state) {
  return state.auth.user.scopes.indexOf(_Constants.FILE_MANAGER_ACCESS) > -1;
};

exports.getHasFileManagerAccessScope = getHasFileManagerAccessScope;

var getUserId = function getUserId(state) {
  return state.auth.user.user_id;
};

exports.getUserId = getUserId;

var getIsUngatedForVideoExperiments = function getIsUngatedForVideoExperiments(state) {
  return state.auth.gates.indexOf(_Constants.VIDEO_EXPERIMENTS_GATE) > -1;
};

exports.getIsUngatedForVideoExperiments = getIsUngatedForVideoExperiments;

var getIsUngatedForCanva = function getIsUngatedForCanva(state) {
  return state.auth.gates.indexOf(_Constants.CANVA_GATE) > -1;
};

exports.getIsUngatedForCanva = getIsUngatedForCanva;

var getIsUngatedForImageOptimization = function getIsUngatedForImageOptimization(state) {
  return state.auth.gates.indexOf(_Constants.IMAGE_OPTIMIZATION_GATE) > -1;
};

exports.getIsUngatedForImageOptimization = getIsUngatedForImageOptimization;

var getUserEmailAddress = function getUserEmailAddress(state) {
  return state.auth.user.email;
};

exports.getUserEmailAddress = getUserEmailAddress;

var getUser = function getUser(state) {
  return state.auth.user;
};

exports.getUser = getUser;